import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'lib-count-alert',
  imports: [CommonModule, TranslateModule, RouterLink],
  templateUrl: './count-alert.component.html',
  styleUrl: './count-alert.component.scss',
})
export class CountAlertComponent {
  @Input() messageKey!: string;
  @Input() count = 0;
  @Input() buttonKey = 'ViewList';
  @Input() url = '';
  @Input() queryParams?: Record<string, any>;
  @Input() type: 'danger' | 'success' | 'warning' = 'danger';
}
